import { Column } from "react-table";

export default [
    {
        Header: 'Group',
        accessor: 'club.name',
        width: '33%'
    },
    {
        Header: 'Email',
        accessor: 'club.email',
        width: '33%'
    },
    {
        Header: 'Head',
        accessor: 'club.owner.email',
        width: '33%'
    },
    {
        Header: 'Discount',
        accessor: 'discount',
        Cell: ({ value }: any) => `${value}%`
    }
] as Column<Resources.ClubPromo>[]